import React from "react";
import Navbar from "@/components/layout/Navbar";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import OverviewTab from "@/components/admin/OverviewTab";
import UsersTab from "@/components/admin/UsersTab";
import AdminOrdersTab from "@/components/admin/AdminOrdersTab";
import AdminPaymentsTab from "@/components/admin/AdminPaymentsTab";
import AdminFunnelTab from "@/components/admin/AdminFunnelTab";
import YoutubeTab from "@/components/admin/YoutubeTab";
import GiftsTab from "@/components/admin/GiftsTab";
import AdminEmailsTab from "@/components/admin/AdminEmailsTab";
import { useI18n } from "@/i18n/I18nContext";
import { ADMIN } from "@/constants/testIds";
import SEO from "@/components/seo/SEO";

export default function Admin() {
  const { t } = useI18n();

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="mx-auto max-w-6xl px-4 py-10 sm:px-6 lg:px-8">
      <SEO title="Administration | Kalypso Music" description="Espace d'administration Kalypso Music." path="/admin" noindex />
        <h1 className="font-heading text-2xl font-medium">{t("admin.title")}</h1>

        <Tabs defaultValue="overview" className="mt-8">
          <TabsList className="grid w-full grid-cols-3 gap-1 sm:grid-cols-8">
            <TabsTrigger value="overview" data-testid={ADMIN.tabOverview}>{t("admin.tabOverview")}</TabsTrigger>
            <TabsTrigger value="users" data-testid={ADMIN.tabUsers}>{t("admin.tabUsers")}</TabsTrigger>
            <TabsTrigger value="orders" data-testid={ADMIN.tabOrders}>{t("admin.tabOrders")}</TabsTrigger>
            <TabsTrigger value="funnel" data-testid={ADMIN.tabFunnel}>{t("admin.tabFunnel")}</TabsTrigger>
            <TabsTrigger value="payments" data-testid={ADMIN.tabPayments}>{t("admin.tabPayments")}</TabsTrigger>
            <TabsTrigger value="youtube" data-testid={ADMIN.tabYoutube}>{t("admin.tabYoutube")}</TabsTrigger>
            <TabsTrigger value="gifts" data-testid={ADMIN.tabGifts}>{t("admin.tabGifts")}</TabsTrigger>
            <TabsTrigger value="emails" data-testid={ADMIN.tabEmails}>{t("admin.tabEmails")}</TabsTrigger>
          </TabsList>
          <TabsContent value="overview" className="mt-6"><OverviewTab /></TabsContent>
          <TabsContent value="users" className="mt-6"><UsersTab /></TabsContent>
          <TabsContent value="orders" className="mt-6"><AdminOrdersTab /></TabsContent>
          <TabsContent value="funnel" className="mt-6"><AdminFunnelTab /></TabsContent>
          <TabsContent value="payments" className="mt-6"><AdminPaymentsTab /></TabsContent>
          <TabsContent value="youtube" className="mt-6"><YoutubeTab /></TabsContent>
          <TabsContent value="gifts" className="mt-6"><GiftsTab /></TabsContent>
          <TabsContent value="emails" className="mt-6"><AdminEmailsTab /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
